import { render } from "./TopCard.vue?vue&type=template&id=854fe898&scoped=true"
import script from "./TopCard.vue?vue&type=script&lang=js"
export * from "./TopCard.vue?vue&type=script&lang=js"

import "./TopCard.vue?vue&type=style&index=0&id=854fe898&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-854fe898"

export default script